<template>
    <v-container>


        <v-layout row justify-center>
            <v-dialog v-model="isLoading" persistent fullscreen content-class="loading-dialog">
            <v-container fill-height>
                <v-layout row justify-center align-center>
                <v-progress-circular :rotate="90" :value="progressValue"
                    :size="200" :width="20" color="pink">
                    </v-progress-circular>
                </v-layout>
            </v-container>
            </v-dialog>
        </v-layout>

        <v-layout row>

            <v-flex>
                <v-btn color="success"  @click="backToHeader()">
                    <v-icon right>fast_rewind</v-icon>
                </v-btn>
            </v-flex>
            <v-flex>
                <h2>Issue Details</h2> 
            </v-flex>
            <v-flex shrink >
                <v-btn v-if="canUpdate"
                    dark small
                    color="pink"
                    @click="saveDetails()"
                    fab
                    class="mx-2"
                    >
                    <v-icon>save</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>
        <v-layout  v-if="issueLocal" column>

            <v-flex v-if="showMessage">
                <div :class="{'dv-message':true,'errorMessage':errorMessage}">
                    {{ message }}
                </div>
            </v-flex>
            <v-flex mt-5>

                <v-layout row wrap>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.issueID"
                            label="Issue ID"
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.issue"
                            label="Issue"
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.issueSubtype"
                            label="Issue Type"
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.description"
                            label="Description"
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.brand"
                            label="Brand"
                        ></v-text-field>
                    </v-flex>

                    <v-flex v-if="currentUser.hdType == 'PROD'" class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.prodOrderNo"
                            label="Prod. Order No."
                        ></v-text-field>
                    </v-flex>

                    <v-flex v-if="currentUser.hdType == 'PROD'" class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.color"
                            label="Color"
                        ></v-text-field>
                    </v-flex>

                    <v-flex v-if="currentUser.hdType == 'PROD'" class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.productLine"
                            label="Product Line"
                        ></v-text-field>
                    </v-flex>

                    <v-flex v-if="currentUser.hdType == 'PROD'" class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.cutQty"
                            label="Cut Qty."
                        ></v-text-field>
                    </v-flex>

                    <v-flex v-if="currentUser.hdType == 'PROD'" class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.affectedQty"
                            label="Affected Qty."
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.department"
                            label="Department"
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.location"
                            label="Location"
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-text-field readonly dense
                            v-model="issue.raisedBy"
                            label="Raised By"
                        ></v-text-field>
                    </v-flex>

                    <v-flex class="issue-field">
                        <v-layout row>
                            <v-flex>
                                <v-text-field readonly dense
                                    v-model="issue.status"
                                    label="Status"
                                ></v-text-field>

                            </v-flex>
                            <v-flex shrink>
                                <v-btn
                                    dark small
                                    color="pink"
                                    @click="updateStatus()"
                                    fab
                                    class="ml-2"
                                    >
                                    <v-icon>check_circle</v-icon>
                                </v-btn>

                            </v-flex>
                        </v-layout>
                    </v-flex>


                    <v-flex class="issue-field">

                        <v-layout v-if="currentUser.userType == 'admin' && issue.status == 'Open' " row>
                            <v-flex>

                                <v-select
                                    :items="assignees"
                                    item-text="assignee"
                                    name="assignee"
                                    v-model="issueLocal.assignedTo"
                                    label="Assignee"
                                >
                                    <template slot='item' slot-scope='{ item }' >
                                        {{ item.assignee }}
                                    </template>

                                </v-select>

                            </v-flex>
                        </v-layout>

                        <v-layout v-else row>
                            <v-flex>
                                <v-text-field readonly dense
                                    v-model="issue.assignedTo"
                                    label="Assigned To"
                                ></v-text-field>

                            </v-flex>
                        </v-layout>


                    </v-flex>

                </v-layout>

            </v-flex>

            <v-flex>
                <v-layout row wrap mx-0>

                    <v-flex class="issue-field">
                        <v-layout v-if="currentUser.userType == 'assignee' 
                            && ( issue.status == 'Open' || issue.status == 'Assigned' ) " row>
                            <v-flex>

                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="issueLocal.commitmentDate"
                                        label="Commitment Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="issueLocal.commitmentDate"
                                    @input="menu2 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>

                        <v-layout v-else row>
                            <div v-if="issue.commitmentDate > minDate">
                                <v-text-field readonly dense
                                    v-model="issue.commitmentDate"
                                    label="Commitment"
                                ></v-text-field>

                            </div>
                            <div v-else>
                                <span>No Commitment Date</span>
                            </div>
                        </v-layout>


                    </v-flex>

                    <v-flex v-if="currentUser.hdType !== 'PROD'" class="issue-field">

                        <v-layout v-if="currentUser.userType == 'assignee' 
                            && ( issue.status == 'Open' || issue.status == 'Assigned' ) " row>
                            <v-flex>

                                <v-select
                                    :items="diagnostics"
                                    item-text="diagnostic"
                                    name="diagnostic"
                                    v-model="issueLocal.diagnostic"
                                    label="Diagnostic"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.diagnostic }}
                                    </template>

                                </v-select>

                            </v-flex>
                        </v-layout>

                        <v-layout v-else row>
                            <v-text-field readonly dense
                                v-model="issue.diagnostic"
                                label="Diagnostic"
                            ></v-text-field>
                        </v-layout>


                    </v-flex>

                    <v-flex class="issue-field">

                        <v-layout v-if="currentUser.userType == 'assignee' 
                            && ( issue.status == 'Open' || issue.status == 'Assigned' ) " row>
                            <v-flex>

                                <v-select
                                    :items="solutions"
                                    item-text="solution"
                                    name="solution"
                                    v-model="issueLocal.solution"
                                    label="Solution"
                                    class="my-4 pa-0"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.solution }}
                                    </template>

                                </v-select>

                            </v-flex>
                        </v-layout>

                        <v-layout v-else row>
                            <v-flex>
                                <v-text-field readonly dense
                                    v-model="issue.solution"
                                    label="Solution"
                                ></v-text-field>

                            </v-flex>
                        </v-layout>


                    </v-flex>

                    <v-flex v-if="currentUser.hdType !== 'PROD'" class="issue-field">

                        <v-layout v-if="currentUser.userType == 'assignee' 
                            && ( issue.status == 'Open' || issue.status == 'Assigned' ) " row>
                            <v-flex>

                            <v-flex>
                                <v-select
                                   :items="solutionTypes"
                                    item-text="solutionType"
                                    name="solutionType"
                                    v-model="issueLocal.solutionType"
                                    label="Solution Type"
                                    class="my-2 pa-0"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.solutionType }}
                                    </template>

                                </v-select>

                            </v-flex>

                            </v-flex>
                        </v-layout>

                        <v-layout v-else row>
                            <v-flex>
                                <v-text-field readonly dense
                                    v-model="issue.solutionType"
                                    label="Solution Type"
                                ></v-text-field>

                            </v-flex>
                        </v-layout>


                    </v-flex>

                    <v-flex v-if="currentUser.hdType !== 'PROD'" class="issue-field">

                        <v-layout v-if="currentUser.userType == 'assignee' 
                            && ( issue.status == 'Open' || issue.status == 'Assigned' ) " row>

                            <v-flex>
                                <v-select
                                   :items="solutionMethods"
                                    item-text="method"
                                    name="method"
                                    v-model="issueLocal.solutionMethod"
                                    label="Solution Method"
                                    class="my-2 pa-0"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.method }}
                                    </template>

                                </v-select>

                            </v-flex>

                        </v-layout>

                        <v-layout v-else row>
                            <v-flex>
                                <v-text-field readonly dense
                                    v-model="issue.solutionMethod"
                                    label="Solution Method"
                                ></v-text-field>

                            </v-flex>
                        </v-layout>


                    </v-flex>

                    <v-flex class="issue-field">

                        <v-layout v-if="currentUser.userType == 'assignee' 
                            && ( issue.status == 'Open' || issue.status == 'Assigned' ) " row>
                            <v-flex ml-2>
                                <v-textarea
                                    solo
                                    name="input-7-4"
                                    label="Solution Desc"
                                    v-model="issueLocal.solutionDesc"
                                    ></v-textarea>

                            </v-flex>
                        </v-layout>

                        <v-layout v-else row>
                            <v-flex>
                                <v-textarea readonly dense
                                    v-model="issue.solutionDesc"
                                    label="Solution Description"
                                ></v-textarea>

                            </v-flex>
                        </v-layout>


                    </v-flex>

                </v-layout>
            </v-flex>

            <v-flex>
                <IssueFiles :issue="issue"></IssueFiles>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
const fb = require('../../firebaseConfig.js')
import IssueFiles from './IssueFiles';
export default {
    components:{ IssueFiles },
    props:['issue'],
    data(){
        return {
            issueLocal:null,
            issueFile:null,
            issueFiles:[],
            progressValue:0,
            disabledBtns:false,
            isLoading: false,
            dialog: false,
            prevSatus:'',
            message:'',
            showMessage:false,
            errorMessage:false,
            canUpdate:false,
            minDate: new Date('1/1/2020')
        }
    },
    computed:{
        ...mapState(['currentUser','assignees','solutions','solutionTypes',
            'diagnostics','solutionMethods']),
    },
    methods:{
        updateStatus(){

            this.errorMessage = false
            this.message = "" 
            this.showMessage = false

            if (this.currentUser.userType == 'assignee'){

                if (this.issueLocal.status == 'Open' || this.issueLocal.status == 'Assigned'){

                    if (this.currentUser.hdType !== 'PROD') {

                        if (this.issueLocal.diagnostic == '' ||
                            this.issueLocal.solution == '' ||
                            this.issueLocal.solutionType == '' ||
                            this.issueLocal.solutionMethod == '' ||
                            this.issueLocal.solutionDesc == ''){

                            this.errorMessage = true;
                            this.message = "Please fill up the diagnostic and solution fields (solution,type,method,desc) !";
                            this.showMessage = true;
                            return;
                        }

                    }else{
                        if (this.issueLocal.solution == '' ||
                            this.issueLocal.solutionDesc == ''){

                            this.errorMessage = true;
                            this.message = "Please fill up the solution fields (solution and desc) !";
                            this.showMessage = true;
                            return;
                        }

                    }

                    this.prevSatus = this.issueLocal.status
                    this.issueLocal.status = 'Closed'
                    fb.issuesCollection.doc(this.issueLocal.id).update({
                        status:'Closed',
                        diagnostic:this.issueLocal.diagnostic,
                        solution:this.issueLocal.solution,
                        solutionType:this.issueLocal.solutionType,
                        solutionDesc:this.issueLocal.solutionDesc,
                        solutionMethod: this.issueLocal.solutionMethod,
                        closedBy: this.currentUser.email,
                        closeDate: new Date()
                    })

                    this.issue.status = 'Closed'
                    this.issue.closedBy = this.currentUser.email
                    this.issue.closeDate = new Date()
                    this.issue.solution = this.issueLocal.solution
                    this.issue.solutionType = this.issueLocal.solutionType
                    this.issue.solutionDesc = this.issueLocal.solutionDesc
                    this.issue.diagnostic = this.issueLocal.diagnostic
                    this.issue.solutionMethod = this.issueLocal.solutionMethod
                    this.message = "Successfully closed issue!"
                    this.errorMessage = false
                    this.showMessage = true


                }else{

                    //can't change Close Status
                    if ( this.issueLocal.status == "Closed"){
                        return
                    }
                    console.log("this.prevSatus",this.prevSatus)
                    if (this.prevSatus != ""){
                        this.issueLocal.status = this.prevSatus
                    }
                    this.prevSatus = this.issueLocal.status

                }
                
                //console.log("this.prevSatus",this.prevSatus)

            }else if (this.currentUser.userType == 'client'  ){
                
                if (this.issueLocal.status == 'Closed' ){
                    this.prevSatus = this.issueLocal.status
                    this.issueLocal.status = "Verified Close"
                }else{
                    
                    console.log("this.prevSatus",this.prevSatus)
                    if (this.prevSatus != ""){
                        this.issueLocal.status = this.prevSatus
                    }
                    this.prevSatus = this.issueLocal.status

                }
                 
            }

        },
        saveDetails(){

            this.errorMessage = false
            this.message = "" 
            this.showMessage = false

            if (this.currentUser.userType == 'client'){
                this.setClientStatus()
            }
            else  if (this.currentUser.userType == 'assignee'){
                this.setAssigneeStatus()
            }
            else  if (this.currentUser.userType == 'admin'){
                this.setAssignee();
            }

        },
        setAssignee(){

            if (this.issueLocal.status != 'Open'){
                return
            }
            if (this.issueLocal.assignedTo == ''){
                this.message = "Please choose an assignee!"
                this.showMessage = true
                this.errorMessage = true
                return
            }

            let assigneeID = 0;

            for(let i = 0;i<this.assignees.length;i++){
                if (  this.issueLocal.assignedTo == this.assignees[i].assignee ){
                    assigneeID = this.assignees[i].assigneeID;
                }
            }

            fb.issuesCollection.doc(this.issueLocal.id).update({
                assignedTo: this.issueLocal.assignedTo,
                assignedToID: assigneeID,
                status:'Assigned',
                asssignedBy: this.currentUser.email,
                assignedDate: new Date()
            })

            this.issue.assignedTo = this.issueLocal.assignedTo
            this.issue.assignedToID = assigneeID
            this.issue.status = 'Assigned'
            this.issue.asssignedBy = this.currentUser.email
            this.issue.assignedDate =  new Date()

            this.message = "Successfully assigned issue!"
            this.errorMessage = false
            this.showMessage = true

        },
        setClientStatus(){

            if (this.issue.status != 'Verified Close' && this.issueLocal.status == 'Verified Close'){

                fb.issuesCollection.doc(this.issueLocal.id).update({
                    status:'Verified Close',
                    verifiedCloseBy: this.currentUser.email,
                    verifiedCloseDate: new Date()
                })
                this.issue.status = 'Verified Close'
                this.issue.verifiedCloseBy = this.currentUser.email
                this.issueverifiedCloseDate = new Date()

                this.message = "This issue is now verified close!"
                this.errorMessage = false
                this.showMessage = true


            }
        },
        setAssigneeStatus(){

            //console.log("this.issueLocal.status",this.issueLocal.status)
            // console.log("this.currentUser",this.currentUser)
            if (this.issue.status != "Closed" && this.issueLocal.status == 'Closed'){

                if (this.issueLocal.diagnostic == '' ||
                    this.issueLocal.solution == '' ||
                    this.issueLocal.solutionType == '' ||
                    this.issueLocal.solutionMethod == '' ||
                    this.issueLocal.solutionDesc == ''){

                    this.errorMessage = true;
                    this.message = "Please fill up the diagnostic and solution fields (solution,type,desc) !";
                    this.showMessage = true;
                    return;
                }

                fb.issuesCollection.doc(this.issueLocal.id).update({
                    status:'Closed',
                    diagnostic:this.issueLocal.diagnostic,
                    solution:this.issueLocal.solution,
                    solutionType:this.issueLocal.solutionType,
                    solutionDesc:this.issueLocal.solutionDesc,
                    solutionMethod: this.issueLocal.solutionMethod,
                    closedBy: this.currentUser.email,
                    closeDate: new Date()
                })

                this.issue.status = 'Closed'
                this.issue.closedBy = this.currentUser.email
                this.issue.closeDate = new Date()
                this.issue.solution = this.issueLocal.solution
                this.issue.solutionType = this.issueLocal.solutionType
                this.issue.solutionDesc = this.issueLocal.solutionDesc
                this.issue.diagnostic = this.issueLocal.diagnostic
                this.issue.solutionMethod = this.issueLocal.solutionMethod
                this.message = "Successfully saved issue details"
                this.errorMessage = false
                this.showMessage = true

            }else if (this.issueLocal.status == "Assigned"){

                //console.log("update commitment date-0",this.issueLocal.commitmentDate)
                let commitmentDate = new Date(this.issueLocal.commitmentDate)
                if (commitmentDate > this.minDate){
                    //console.log("update commitment date",commitmentDate)
                    fb.issuesCollection.doc(this.issueLocal.id).update({
                        commitmentDate:commitmentDate,
                        diagnostic:this.issueLocal.diagnostic,
                        solution:this.issueLocal.solution,
                        solutionType:this.issueLocal.solutionType,
                        solutionDesc:this.issueLocal.solutionDesc,
                        solutionMethod: this.issueLocal.solutionMethod,
                    })
                    this.issue.commitmentDate = commitmentDate
                    this.issue.solution = this.issueLocal.solution
                    this.issue.solutionType = this.issueLocal.solutionType
                    this.issue.solutionDesc = this.issueLocal.solutionDesc
                    this.issue.diagnostic = this.issueLocal.diagnostic
                    this.issue.solutionMethod = this.issueLocal.solutionMethod

                    this.message = "Successfully saved issue details"
                    this.errorMessage = false
                    this.showMessage = true

                }
                
            }

        },
        backToHeader(){
            //console.log(this.issue)
            //console.log(this.issueLocal)
            this.issueLocal = null
            this.$emit('close')
        },

    },
    mounted(){

        console.log("Mounted Issue Det");
        this.prevStatus = this.issue.status
        this.issueLocal = {...this.issue}
        console.log("this.issueLocal",this.issueLocal)
        //console.log("this.issueLocal.commitmentDate",this.issueLocal.commitmentDate)
        if ( this.issueLocal.commitmentDate ){
            if (this.issueLocal.commitmentDate < this.minDate){
                this.issueLocal.commitmentDate = null
            }else{
                this.issueLocal.commitmentDate = new Date(this.issueLocal.commitmentDate).toISOString().slice(0,10);
            }
        }

        this.canUpdate = false
        if (this.currentUser.userType == 'client' ||
            this.currentUser.userType == 'assignee' ||
            this.currentUser.userType == 'admin'){
            this.canUpdate = true
        }

        //console.log("this.$store.state.solutionMethods",this.$store.state.solutionMethods)

    }
}
</script>
<style scoped>
.issue-field{
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 5px;
    min-width: 280px;
    max-width: 280px;
    margin-right: 15px;
}
.issue-value{
    text-align: left;
}
.label-text{
    min-width: 100px;
    max-width: 100px;
    font-weight: bold;
}

.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}
.truncate {
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


</style>